import { PacketValueSerialType } from "../../../enum/PacketValueSerialType";
import { Input, KeyCode } from "../../../lib/Input";
import { Physics } from "../../../math/Physics";
import Vector2 from "../../../math/Vector2";
import { clamp01 } from "../../../util";
import Color from "../../../util/Color";
import Ability from "../../Ability";
import Explosion from "../../Explosion";
import Player from "../../Player";

export default class EMP extends Ability {

    targets: Player[] = [];
    size = 256;
    position: Vector2 = Vector2.zero;

    color = Color.fromHex("#55ff55");

    constructor(player: Player) {
        super(player, {
            cooldown: 20,
            duration: 5,
            energyCost: 35,
            icon: 1,
            trigger: KeyCode.Digit2,
            triggerType: Input.GetKeyUp,
            info: `EMP (20s cooldown) - Creates an EMP shockwave covering a 256U radius, disabling all enemies movement in range for 5 seconds`
        })
    }

    onDurationEnd(): void {
        for (const target of this.targets) {
            target.isDisabled = false;
            this.player.engine.sendUpdatePacket(target, "PLAYER", [
                {
                    key: "isDisabled",
                    value: false,
                    type: PacketValueSerialType.Bool
                }
            ]);
        }

        this.targets = [];
    }

    onActiveUpdate(): void {
        
    }

    onUse(): void {
        this.position = this.player.transform.position;
        this.targets = [];
        const validPlayers = this.player.engine.GetGameObjectsBehaviors<Player>(Player).filter(
            v => !v.isDead && v.team && v.team !== this.player.team
        );

        for (const player of validPlayers) {
            if (Physics.CircleCircleCollision({
                position: this.position,
                radius: this.size
            }, {
                position: player.transform.position,
                radius: player.size
            }) !== false) {
                this.targets.push(player);
                player.isDisabled = true;
                this.player.engine.sendUpdatePacket(player, "PLAYER", [
                    {
                        key: "isDisabled",
                        value: true,
                        type: PacketValueSerialType.Bool
                    }
                ]);
            }
        }

        if (this.targets.length === 0) this.durationTimer = 0;

        const [, expl] = this.player.engine.NewGameObjectWithScript<Explosion>(Explosion);
        expl.transform.position = this.position;
        expl.size = this.size;
        expl.w = this.size * 2;
        expl.color = new Color(80, 255, 80);

        this.player.engine.sendCreatePacket(expl.gameObject, {
            type: "EXPLOSION",
            values: [
                {
                    key: "size",
                    value: expl.size,
                    type: PacketValueSerialType.Byte
                },
                {
                    key: "w",
                    value: expl.w,
                    type: PacketValueSerialType.Byte
                },
                {
                    key: "color",
                    value: expl.color,
                    type: PacketValueSerialType.Color
                },
            ]
        });
    }

    onKeydownDraw(): void {
        this.player.ctx.fillStyle = '#55ff5555';
        this.player.engine.FillCircle(this.player.transform.position, this.size);
    }

    onDraw(): void {
        if (this.isCurentlyActive) {
            const alpha = clamp01(this.durationTimer/this.duration);
            this.player.ctx.strokeStyle = this.color.toHexWithAlpha(alpha);
            this.player.ctx.lineWidth = 2;
            this.player.engine.StrokeCircle(this.position, this.size);
        }
    }
}